import React, { useEffect } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { Box } from "@chakra-ui/react";
import ProductsTab from "../../components/admin/ProductsTab";

export default function Products() {
  useEffect(() => {
    document.title = "Products";
  }, []);

  return (
    <React.Fragment>
      <DashboardLayout>
        <Box mt='20px'>
          <ProductsTab />
        </Box>
      </DashboardLayout>
    </React.Fragment>
  )
}